// extracted by mini-css-extract-plugin
export default {"container":"SearchBackHeader_container--rfz","back":"SearchBackHeader_back--bah","title":"SearchBackHeader_title--M9t"};